import type {
  Candidate,
  Deal,
  Heatmap,
  HistoryPoint,
  Hub,
  OriginMonthStats,
  Run,
  Settings,
  Status,
} from "./types";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    headers: { "Content-Type": "application/json" },
    ...init,
  });
  if (!response.ok) {
    // Der Text der Antwort ist oft aussagekraeftiger als der Statuscode --
    // FastAPI legt dort die Validierungsmeldung ab.
    const body = await response.text();
    throw new Error(`${response.status}: ${body.slice(0, 300)}`);
  }
  return (await response.json()) as T;
}

export const api = {
  status: () => request<Status>("/api/status"),
  runs: () => request<Run[]>("/api/runs?limit=10"),

  candidates: (params: { onlyAccepted?: boolean; origin?: string } = {}) => {
    const query = new URLSearchParams();
    if (params.onlyAccepted) query.set("only_accepted", "true");
    if (params.origin) query.set("origin", params.origin);
    const suffix = query.toString();
    return request<Candidate[]>(`/api/candidates${suffix ? `?${suffix}` : ""}`);
  },

  deals: () => request<Deal[]>("/api/deals?limit=25"),

  heatmap: (lookbackDays = 14) =>
    request<Heatmap>(`/api/prices/heatmap?lookback_days=${lookbackDays}`),
  history: (lookbackDays = 90) =>
    request<HistoryPoint[]>(`/api/prices/history?lookback_days=${lookbackDays}`),
  stats: (lookbackDays = 90) =>
    request<OriginMonthStats[]>(`/api/prices/stats?lookback_days=${lookbackDays}`),

  settings: () => request<Settings>("/api/settings"),
  patchSettings: (patch: Partial<Settings>) =>
    request<Settings>("/api/settings", { method: "PATCH", body: JSON.stringify(patch) }),

  hubs: () => request<Hub[]>("/api/hubs"),
  patchHub: (iata: string, patch: { enabled?: boolean; min_layover_minutes?: number }) =>
    request<Hub>(`/api/hubs/${iata}`, { method: "PATCH", body: JSON.stringify(patch) }),
};
